import React from 'react';
import './NavBarPlayList.scss';
import AddPlayList from './AddPlayList';
import PlayListTracks from './PlayListTracks';
import { useDataLayerValue } from '../../../DataLayer';


function PlayList(props) {
    const [{ lang }] = useDataLayerValue();
    return (
        <div className="nav-bar__play-list">
            <h4 className="nav-bar__play-list_title" as="h1">{lang === 'en' ? 'Playlists' : 'Danh sách phát'}</h4>
            <AddPlayList />
            <PlayListTracks />
            <hr className="nav-bar__play-list__hr"></hr>
        </div>
    );
}

export default PlayList;